var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_60475_40852",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_60475_40852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "content_copy",
    d: "M8 15C7.54167 15 7.14931 14.8368 6.82292 14.5104C6.49653 14.184 6.33333 13.7917 6.33333 13.3333V3.33332C6.33333 2.87499 6.49653 2.48263 6.82292 2.15624C7.14931 1.82985 7.54167 1.66666 8 1.66666H15.5C15.9583 1.66666 16.3507 1.82985 16.6771 2.15624C17.0035 2.48263 17.1667 2.87499 17.1667 3.33332V13.3333C17.1667 13.7917 17.0035 14.184 16.6771 14.5104C16.3507 14.8368 15.9583 15 15.5 15H8ZM8 13.3333H15.5V3.33332H8V13.3333ZM4.66667 18.3333C4.20833 18.3333 3.81597 18.1701 3.48958 17.8437C3.16319 17.5174 3 17.125 3 16.6667V4.99999H4.66667V16.6667H13.8333V18.3333H4.66667Z",
    fill: "#5F5C71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopye);
export default __webpack_public_path__ + "static/media/copye.8c594c2b9f5d224d44dd6bf5b8ea4bec.svg";
export { ForwardRef as ReactComponent };